import React from "react";
import logo from "../../assets/images/logo.jpg";
import eye from "../../assets/images/eye.png";
import upArrow from "../../assets/images/upArrow.png";
import axios from "axios";
import severUrl from "../../api";
import { useEffect, useState } from "react";
import { Tooltip as ReactTooltip } from "react-tooltip";
import thankyou from "../../assets/images/thanks.png"


export const SearchItem = (props) => {
  const { thumnail, title, description, tag, slug, ava, created, mAvai, currVer, authors, total_visited } = props.data;
  const [short, setShort] = useState("")
  const handleOnclick = (e) => {
    e.preventDefault();
    // console.log(e.target.value); //will give you the value continue
    // console.log(tag)
    axios
      .get(severUrl + "blog/" + e.target.value + "/list/tag/")
      .then((response) => {
        // console.log(response.data);
        localStorage.setItem("key", e.target.value);
        localStorage.setItem("search_list", JSON.stringify(response.data));
        window.location.href = "/home";
      });
  };

  useEffect(() => {
    const short = description.substring(0, 200) + "..."
    setShort(short)
  }, [description]);

  return (
    <>
      {/* <span
        style={{
          width: "100%",
          borderBottom: "dotted 1px #333",
          display: "block",
          opacity: "0.3",
          height: "1px",
          color: "gray"
        }}
      ></span> */}
      <div className="search-item">
        {thumnail === "" &&
          <div className="thumnails">
            {severUrl !== "http://127.0.0.1:8000/" && <img loading="lazy" alt="thumnail-image" src={thumnail ? thumnail : logo} />}
            {severUrl == "http://127.0.0.1:8000/" && <img loading="lazy" alt="thumnail-image" src={thumnail ? severUrl + thumnail : logo} />}
          </div>}
        {thumnail && <div className="thumnails">
          <img className="thumnail-image" alt="thumnail-image" style={{ width: "100%", height: "100%", objectFit: "cover" }} loading="lazy" src={thumnail} />
        </div>}
        <div className="item-content" style={{
          borderBottom: "1px solid #d2d2d2", paddingTop: "3em",
          paddingBottom: "3em"
        }}>
          <div style={{ display: "flex", flexDirection: "column", justifyContent: "space-between", width: "100%" }}>
            <a style={{ fontWeight: "bold", width: "fit-content", fontSize: "18px", maxWidth: "90%", marginBottom: "5px" }} href={slug}>{title}</a>
            <div style={{ display: "flex", flexDirection: "row", justifyContent: "start", width: "100%", alignContent: "start" }}>

              <div style={{ fontWeight: "400", color: "black", textAlign: "start", marginLeft: "1px", fontSize: "13px", marginBottom: '5px' }}>{created}</div>

              <div>
                <img src={eye} style={{width: "18px", height:"15px", marginBottom: "10px", marginLeft: "10px"}} />
              </div>

              <div data-tooltip-id="my-tooltip-1" style={{ paddingLeft: "5px", marginBottom: "10px", fontSize: "13px", fontWeight: "400"}}>{total_visited}</div>

              <ReactTooltip
                  id="my-tooltip-1"
                  place="bottom"
                  content="Views"
              />

              <div>

              <img src={upArrow} style={{width: "18px", height:"15px", marginBottom: "10px", marginLeft: "10px"}} /></div>

              <div data-tooltip-id="my-tooltip-5" style={{ paddingLeft: "5px", marginBottom: "10px", fontSize: "13px", fontWeight: "400"}}>1</div>
              
                <ReactTooltip
                  id="my-tooltip-5"
                  place="bottom"
                  content="Upgraded times"
                />
            </div>
          </div>
          {/* <a
            style={{ fontSize:"14px", height: "24px", fontWeight: "300", color: "green", backgroundColor: "transparent", border: "none", marginRight: "10px", borderRadius: "5px", paddingLeft: "0", marginTop: "2px" }}
          >v{currVer}</a> */}
          {authors.length != 0 &&
          <div
             style={{
        width: "100%",
        display: "flex",
        flexDirection: "row",
        alignContent: "center",
        alignItems: "center",
        textAlign: "center",
        height: "24px"
        // marginBottom: "20px",
      }}
          >
            <img style={{height:"48px"}} src={thankyou}/>
           <div style={{ marginTop: "0", fontWeight: "480", textAlign: "left", marginLeft: "5px", fontSize:"12px", paddingBottom:"0px", alignContent:"center" }}>{' ' + authors}</div>
           </div>
          }
          {mAvai && <div style={{ textAlign: "left", color: "green", fontWeight: "bold", width: "fit-content", padding: "5px", borderRadius: "5px", fontSize: "12px", paddingLeft: 0 }}>Model available</div>}
          <div className="search-result-description" style={{ fontWeight: "1.7em" }}>{short}</div>
          <div style={{ display: "flex", flexDirection: "row", marginTop: "5px" }}>
            {Array.from(tag).map((t, index) => (<>
              <div style={{
                height: "100%", alignItems: "center",     /* align-items: center; */
                marginRop: "5px",
                paddingTop: "5px"
              }}>
                <span style={{ display: (index == 0) ? "none" : "inline-block", fontSize: "23px", alignItems: "center" }} class="dot"></span></div>
              <button
                // style={{ height:"24px", fontWeight: "bold", fontSize: "8", color: "brown", backgroundColor: "transparent", border: "none", marginRight: "5px", borderRadius: "5px", paddingLeft: "0" }}
                style={{ margin: "5px", marginLeft: 0 }}
                className="button-4"
                value={t}
                onClick={handleOnclick}
              >
                {t}
              </button></>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};
